import { Button } from "@mui/material";
import { BRAND_BLUE, BRAND_BLUE_DARK } from "../theme/appTheme";

// The filled brand-blue button used for every primary action on the auth
// screens (sign in, send code, verify, try again, ...).
function AuthPrimaryButton({ children, sx, ...rest }) {
  return (
    <Button
      fullWidth
      size="medium"
      variant="contained"
      sx={{
        py: 1,
        borderRadius: 1.5,
        fontWeight: 600,
        fontSize: "0.8125rem",
        textTransform: "none",
        bgcolor: BRAND_BLUE,
        color: "#ffffff",
        "&:hover": { bgcolor: BRAND_BLUE_DARK },
        "&.Mui-disabled": { bgcolor: "#e5e7eb", color: "#9ca3af" },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}

export default AuthPrimaryButton;
